import React from 'react';
import cn from 'classnames';
import { Popconfirm, PopconfirmProps } from 'antd';
import css from './PopConfirm.scss';

interface Props extends PopconfirmProps {
	theme?: 'light';
}

export const PopConfirm = ({ theme = 'light', okText = 'Yes', cancelText = 'No', ...props }: Props) => (
	<Popconfirm
		destroyOnHidden
		okText={okText}
		cancelText={cancelText}
		{...props}
		classNames={{ root: cn(props.overlayClassName, css[theme]) }}
	/>
);
